import {
    TransactionAction,
    TransactionsActions,
} from '../actions/transactions.actions';
import { WithdrawAction } from '../models/action.model';
import { TransactionStatusState } from '../state/transaction-status.state';

export const initialTransactionStatusState: TransactionStatusState = {
    '': [
        {
            Status: '',
            PaymentSystemName: '',
        },
    ],
};

export function transactionStatusReducer(
    state = initialTransactionStatusState,
    action: TransactionAction
): TransactionStatusState {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const transactionId: string = action.transactionId;

            return {
                ...state,
                [transactionId]: getStatusAndPaymentSystem(action.actions)
            };
        default:
            return state;
    }
}

export function getStatusAndPaymentSystem(
    actions: WithdrawAction[]
): Array<{ Status: string; PaymentSystemName: string | null }> {
    return actions.map((action) => ({
        Status: action.status,
        PaymentSystemName: action.metadata?.paymentSystem ?? null,
    }));
}
